module.exports = __webpack_public_path__ + "img/2.0a3bdbd1.png";